import {Stack, Typography} from "@mui/material";
import {appStyles} from "../../../../AppStyles.ts";

function UXIntelAssociationsPanel() {
    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Intelligence Associations</Typography>
            </Stack>
        </Stack>
    );
}

export default UXIntelAssociationsPanel;
